import { Flex, Image, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

export const PaymentFeature: FC<SecondaryFooterProps> = ({ data }) => {
  const { getDirectusImage } = useDirectus();
  return (
    <Flex flexDirection="column" align="center" gap={24}>
      <Flex align="center" gap={32}>
        {(data.top_logos ?? []).map((logo, index) => {
          const imageWidth =
            logo?.secondary_layout_footer_logos_id?.logo?.mobile_image_width ??
            undefined;
          const imageHeight =
            logo?.secondary_layout_footer_logos_id?.logo?.mobile_image_height ??
            undefined;
          return (
            <Image
              key={index}
              value={getDirectusImage(
                logo?.secondary_layout_footer_logos_id?.logo?.image?.id ?? "",
                {
                  width: imageWidth ? imageWidth * 2 : undefined,
                  height: imageHeight ? imageHeight * 2 : undefined,
                  format: "webp",
                  quality: 75,
                },
              )}
              image={{
                alt:
                  logo?.secondary_layout_footer_logos_id?.logo
                    ?.alternative_text ?? "",
              }}
              width={imageWidth}
              height={imageHeight}
            />
          );
        })}
      </Flex>
      <Flex flexDirection="column" align="center" gap={16}>
        <Typography size="small" color="text-primary-muted">
          {data?.translations?.[0]?.footer_middle_text}
        </Typography>
        <Flex align="center" gap={8}>
          {(data.middle_logos ?? []).map((logo, index) => {
            const imageWidth =
              logo?.secondary_layout_footer_logos_id?.logo
                ?.mobile_image_width ?? undefined;
            const imageHeight =
              logo?.secondary_layout_footer_logos_id?.logo
                ?.mobile_image_height ?? undefined;

            return (
              <Image
                key={index}
                value={getDirectusImage(
                  logo?.secondary_layout_footer_logos_id?.logo?.image?.id ?? "",
                  {
                    width: imageWidth ? imageWidth * 2 : undefined,
                    height: imageHeight ? imageHeight * 2 : undefined,
                    format: "webp",
                    quality: 70,
                  },
                )}
                image={{
                  alt:
                    logo?.secondary_layout_footer_logos_id?.logo
                      ?.alternative_text ?? "",
                }}
                width={imageWidth}
                height={imageHeight}
              />
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};
